export const SET_APP_CONFIGS = 'SET_APP_CONFIGS';
export const SET_CURRENCY = 'SET_CURRENCY';
